import React from 'react'

const StatisticIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M421.3 2c-13.7 4.9-24.2 15.8-28.8 29.8-1.3 4.2-1.6 7.9-1.4 16.2l.4 10.9-25.2 18.9-25.2 18.9-6.3-3c-5.4-2.6-7.8-3.1-16.4-3.5-7.9-.3-11.3-.1-15.5 1.3-14.3 4.6-25.1 15.2-30 29.2-2.5 7.4-2.6 20.7 0 28l1.7 5.2-30 29.8-30.1 29.9-5-1.7c-6.6-2.4-20.4-2.5-27.1-.2-5.5 1.9-10.6 4.6-14.7 8l-2.8 2.3-22-11-21.9-11v-6.8c0-18.2-12.5-35-30.7-41.3-10.9-3.7-27.7-2.1-37 3.7C38.5 164.9 31 178.1 31 195c0 25.8 19.1 45 45 45 11.4 0 20.1-3 28.3-9.7l2.8-2.3 22 11 21.9 11v6.8c0 18.2 12.5 35 30.7 41.3 7.6 2.6 20.9 2.6 28.5 0 13.8-4.7 24.2-15.1 28.9-28.8 2.5-7.3 2.5-20.8 0-27.8l-1.7-5 29.9-30.1 29.8-30 5.2 1.7c7.3 2.6 20.6 2.5 28 0 14-4.9 24.6-15.7 29.2-29.9 1.3-4.2 1.6-7.9 1.4-16.2l-.4-10.9 25.2-18.9 25.2-18.9 6.3 3c5.4 2.6 7.8 3.1 16.4 3.5 7.9.3 11.3.1 15.5-1.3C468.9 82.1 481 65.6 481 45c0-20.1-11.7-36.5-30.7-43.1-7.5-2.5-21.6-2.5-29 .1z"
      />
      <path
        fill={color}
        d="M397.6 151.9c-1.5 1-3.7 3.2-4.7 4.7-1.8 2.8-1.9 7.9-1.9 164.1V482h-30V365.7c0-112.1-.1-116.3-1.9-119.1-1-1.5-3.2-3.7-4.7-4.7-2.7-1.8-5.3-1.9-38.4-1.9s-35.7.1-38.4 1.9c-1.5 1-3.7 3.2-4.7 4.7-1.8 2.8-1.9 7-1.9 119.1V482h-30v-56.3c0-53.4-.1-56.3-1.9-59.1-1-1.5-3.2-3.7-4.7-4.7-2.7-1.8-5.3-1.9-38.4-1.9s-35.7.1-38.4 1.9c-1.5 1-3.7 3.2-4.7 4.7-1.8 2.8-1.9 5.7-1.9 59.1V482h-30v-86.3c0-82.8-.1-86.3-1.9-89.1-1-1.5-3.2-3.7-4.7-4.7-2.7-1.8-5.3-1.9-38.4-1.9s-35.7.1-38.4 1.9c-1.5 1-3.7 3.2-4.7 4.7-1.8 2.8-1.9 6.3-1.9 89.1V482H20.3c-8.9 0-11.3.3-13.7 1.9C2 487 0 490.8 0 497c0 6.2 2 10 6.6 13.1 2.8 1.8 9.6 1.9 249.4 1.9s246.6-.1 249.4-1.9c4.6-3.1 6.6-6.9 6.6-13.1 0-6.2-2-10-6.6-13.1-2.4-1.6-4.8-1.9-13.6-1.9H481V320.7c0-156.2-.1-161.3-1.9-164.1-1-1.5-3.2-3.7-4.7-4.7-2.7-1.8-5.3-1.9-38.4-1.9s-35.7.1-38.4 1.9z"
      />
    </svg>
  )
}

StatisticIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default StatisticIcon
